// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hYag","content":"styles_content__3GohR","row":"styles_row__2tnl5","footer":"styles_footer__1TRvh","phraseLength":"styles_phraseLength__1T8i0"};